import { render } from "./edit-products.vue?vue&type=template&id=35918e56"
import script from "./edit-products.vue?vue&type=script&lang=js"
export * from "./edit-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__